function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16,17.84a4.65,4.65,0,0,1-4.36-4.9,4.48,4.48,0,0,1,4.24-4.7H16a4.48,4.48,0,0,1,4.36,4.59v.1A4.68,4.68,0,0,1,16,17.84ZM9.17,26a1.8,1.8,0,0,1-1.33-.47c-.22-.29-.07-.84.08-1.18l.37-.78a16.22,16.22,0,0,1,2.17-3.38,1.75,1.75,0,0,1,2.11-.34,6.17,6.17,0,0,1,1,.84,3.24,3.24,0,0,0,2.16.69h.68a3.34,3.34,0,0,0,2.18-.69,4.73,4.73,0,0,1,1-.84,1.56,1.56,0,0,1,2,.36,13.71,13.71,0,0,1,2.09,3.41l.38.78c.15.3.31.91.1,1.16a1.52,1.52,0,0,1-1.25.45Z",
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.73,11a.85.85,0,0,1,.84.84v2a.83.83,0,0,1-.83.82h-1a.83.83,0,0,1-.83-.82V11.9a1.11,1.11,0,0,1,.55-.84s.08,0,.09-.07v0h0A5.77,5.77,0,0,0,16,6.86,6,6,0,0,0,10.52,11c0,.19.09.09.27.19a.74.74,0,0,1,.45.76v1.92a.93.93,0,0,1-.63.83c-.09.1,0,.19,0,.28a5.74,5.74,0,0,0,3.76,3.73c.45.1.18-.47,1-.47h1.56a.67.67,0,0,1,.65.67h0v.79a.68.68,0,0,1-.65.67H15.4c-.36,0-.64-.1-.73-.47a.48.48,0,0,0-.45-.29,7.1,7.1,0,0,1-4.41-4.41c-.09-.2-.09-.37-.37-.37l-.09-.1a.82.82,0,0,1-.83-.82h0v-2a.91.91,0,0,1,.91-.84c.1,0,.28,0,.28-.17A6.76,6.76,0,0,1,16,6a6.56,6.56,0,0,1,6.36,4.89A.51.51,0,0,0,22.73,11Z",
    style: {
      fill: "#00a8e9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceQueue);
export default __webpack_public_path__ + "static/media/presence-queue.fcfbc8aa.svg";
export { ForwardRef as ReactComponent };